module.exports = __webpack_public_path__ + "img/icon_bg4.f3ee2c59.png";